<template>
  <div>
    <div>
      <nav-bar />
    </div>
    <br>
    <router-link :to="{name:'resumen'}" tag="a" class="alignA" >Regresar</router-link>
    <br>
    <h3>Bitácora [Viaje Cliente: {{Ids.travelNumber}} - Placa Vehículo:{{Ids.license}}]</h3>
    <div class="containerTable">
      <table class="table">
        <caption/>
        <thead>
          <tr>
            <th scope="col">No. de Viaje</th>
            <th scope="col">Fecha de Registro</th>
            <th scope="col">Puesto de Control</th>
            <th scope="col">Placa</th>
            <th scope="col">Nombre Conductor</th>
            <th scope="col">Celular</th>
            <th scope="col">Usuario</th>
            <th scope="col">Observación</th>
            <th scope="col">Foto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{item.tripNumber}}</td>
            <td>{{item.registrationDate}}</td>
            <td>{{item.NamePointControl}}</td>
            <td>{{item.licensePlate}}</td>
            <td>{{item.nameDriver}}</td>
            <td>{{item.cellPhone}}</td>
            <td>{{item.userName}}</td>
            <td>{{item.remark}}</td>
            <td>
              {{item.imagePC}}
              <b-button
                size="sm"
                class="mr-1"
                @click.stop="info(item, item.index, $event.target)"
              >ver</b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
    <!-- Info modal -->
    <b-modal id="modalInfo" :title="modalInfo.title" ok-only @hide="resetModal">
      <div>
        <b-carousel
          id="carousel1"
          :interval="4000"
          v-model="slide"
          style="text-shadow: 1px 1px 2px #333;"
          controls
          indicators
          background="#ababab"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide v-for="(i, index) of img" :key="index">
            <img slot="img" :src="'data:image/jpeg;base64,'+i" class="image">
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>
  </div>
</template>
<script>
import navBar from "@/components/NavBar.vue";

export default {
  components: {
    navBar
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "IdTrackingPointControl",
          thClass: "d-none",
          tdClass: "d-none"
        },
        {
          key: "tripNumber",
          label: "No. de Viaje",
          sortable: true
        },
        {
          key: "registrationDate",
          label: "Fecha de Registro",
          sortable: true
        },
        {
          key: "NamePointControl",
          label: "Puesto de Control",
          sortable: true
        },
        {
          key: "licensePlate",
          label: "Placa",
          sortable: true
        },
        {
          key: "nameDriver",
          label: "Nombre Conductor",
          sortable: true
        },
        {
          key: "cellPhone",
          label: "Celular",
          sortable: true
        },
        {
          key: "userName",
          label: "Usuario",
          sortable: true
        },
        {
          key: "remark",
          label: "Observación",
          sortable: true
        },
        {
          key: "imagePC",
          label: "Foto"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 20, 30, 40],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      modalInfo: { title: "", content: "" },
      striped: true,
      bordered: true,
      id_tracking: 0,
      img: {},
      license: "",
      TravelNumber: "",
      slide: 0,
      userInfo: {},
      Ids: {
        travelNumber: "",
        license: ""
      }
    };
  },
  created() {
    if (this.$session.get("login-storage")) {
      this.userInfo = this.$session.get("login-storage");
    }

    this.axios
      .get("PC/GetDetailTrackingPC", {
        params: {
          id_tracking: this.$route.params.id_tracking,
          transport_company_name: this.$route.params.transport_company_name
        }
      })
      .then(response => {
        this.items = response.data;
        this.totalRows = this.items.length;
        console.log(response.data);
      });

    this.axios
      .get("PC/GetIdsbinnacle", {
        params: {
          id_tracking: this.$route.params.id_tracking,
          transport_company_name: this.$route.params.transport_company_name
        }
      })
      .then(res => {
        this.Ids.travelNumber = res.data.tripNumber;
        this.Ids.license = res.data.licensePlate;
        console.log(res.data);
      });
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    return() {
      this.$router.push({ name: "resumen" });
    },
    info(item, index, button) {
      this.modalInfo.title = "Fotos del viaje";
      this.axios
        .get("PC/GetImagesTrackingFromS3Async", {
          params: {
            id_tracking: JSON.stringify(item.Id)
          }
        })
        .then(response => {
          this.img = response.data;
          this.modalInfo.content = "Acá van a ir las imágenes";
          this.$root.$emit("bv::show::modal", "modalInfo", button);
        });
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  }
};
</script>
<style>
.containerTable {
  overflow: auto;
  height: 90% !important;
}
.alignA {
  float: left;
  padding-left: 50px;
}
.image {
  height: 600px;
  width: 500px;
}
</style>

